<script lang="ts" setup>
    import { ref, nextTick } from "vue";
    import { ITimelineImmunization, ITimelineSectionClick, TimelineSection } from "../lib/Models/EMR/TimelineModel";
    import { NoTzDate } from '../lib/DateUtils';

    defineExpose({buildDisplay});
    const emit = defineEmits<{
        (e: "displayBuiltSection", strValue: ITimelineSectionClick): void
    }>(); 

    const immunizationDisplay = ref<ITimelineImmunization[]>();

    function refused(item: ITimelineImmunization) {
        return item.refused;
    }

    function buildDisplay(immunizationList: ITimelineImmunization[], date: NoTzDate) {
        immunizationDisplay.value = immunizationList.filter(item => item.encounterDate === date);

        nextTick(() => { 
            const element = document.getElementById("immunizationDisplayHtml");
            if (!element)
                return;
            const timelineSectionClick: ITimelineSectionClick =  {
                id: TimelineSection.Immunizations,
                date: date,
                html: element.outerHTML
            }
            emit("displayBuiltSection", timelineSectionClick);
        }); 
    }

</script>

<template>
    <table id="immunizationDisplayHtml"><colgroup>
    <col class="col-width-150"><col class="col-width-100"><col class="col-width-100"><col class="col-width-110"><col class="col-width-140"></colgroup>
    <tr><th class=vaccine_title>Vaccine</th><th class=vaccine_title>Next Due</th><th class=vaccine_title>Location</th><th class=vaccine_title>Type</th><th class=vaccine_title>Reaction</th></tr>
    <tr v-for="item in immunizationDisplay">
        <td v-if="refused(item)" colspan=5 style="color: red">{{item.immunizationName}}</td>
        <td v-if="!refused(item)">{{item.immunizationName}}</td><td>{{item.nextDue ?? ""}}</td><td>{{item.location ?? ""}}</td><td>{{item.type ?? ""}}</td><td>{{item.reaction ?? ""}}</td>
    </tr>
    </table>
</template>